<template>
  <div class="video-talk">
    <!-- <div v-wechat-title="agoraRoom?(agoraRoom.member.name||agoraRoom.member.nickName):'洽谈间-客服'" ></div> -->
    <div class="video_wrap" @click="show = !show" :class="remoteStreams.length == 3 ? 'list_3' : ''">
      <div class="stream " :class="['stream-t' + remoteStreams.length, remoteStreams.length == 1 ? 'stream1' : 'stream0', 'item_count' + (remoteStreams.length + 1)]">
        <div class="stream_video">
          <StreamPlayer :stream="localStream" v-if="localStream" :domId="localStream.getId()"></StreamPlayer>
          <div class="close_video" v-if="!myVideo">
            <i class="icon iconfont icon-video_off"></i>
            <p>Camera off</p>
          </div>
        </div>
      </div>
      <!-- <div class="stream "  :class="['stream-t'+remoteStreams.length,remoteStreams.length==1?'stream0':'stream1']" v-if="remoteStreams.length">
        <div class="stream_video">
          <StreamPlayer :stream="remoteStreams[0].stream"  :domId="remoteStreams[0].id"></StreamPlayer>
        </div>
        <div class="close_video" v-if="!remoteStreams[0].video">
          <i class="icon iconfont icon-video_off"></i>
          <p>对方未开启摄像头</p>
        </div>
      </div> -->
      <!-- <template v-if="remoteStreams.length>1"> -->
      <div
        class="stream "
        @click.stop="streamClick(item)"
        :class="['stream-t' + remoteStreams.length, remoteStreams.length == 1 ? 'stream0' : 'stream1']"
        v-for="(item, index) in remoteStreams"
        :key="item.id"
      >
        <div class="stream_video">
          <StreamPlayer :stream="item.stream" :domId="item.id"></StreamPlayer>
        </div>
        <div class="close_video" v-if="!item.video">
          <i class="icon iconfont icon-video_off"></i>
          <p>The other side didn't turn on the camera</p>
        </div>
      </div>
      <!-- </template> -->
    </div>
    <div class="pc_bottom">
      <div class="handle">
        <div class="menu-item" @click="selectVideo">
          <i class="icon iconfont icon-video_on" v-if="myVideo"></i>
          <i class="icon iconfont icon-video_off off" v-else></i>
          <span>Camera</span>
        </div>
        <div class="menu-item" @click="selectAudio">
          <i class="icon iconfont icon-speaker_on" v-if="myAudio"></i>
          <i class="icon iconfont icon-speaker_off off" v-else></i>
          <span>Sound</span>
        </div>
        <div class="menu-item" :class="videoDeviceList.length < 2 ? 'no' : ''" @click="selectCamera">
          <i class="icon iconfont icon-qiehuanshexiangtou"></i>
          <span>Switch</span>
        </div>
        <div class="menu-item" @click="selectInvite">
          <i class="icon iconfont icon-add"></i>
          <span>invite</span>
        </div>
      </div>
      <div class="exit" @click="outClick">
        <div class="icon_div">
          <i class="iconfont icon-tuichu "></i>
        </div>
        Exit
      </div>
    </div>
    <van-popup v-model="show" round class="video_bottom" :overlay="false" position="bottom">
      <div class="menu-item" @click="selectVideo">
        <i class="icon iconfont icon-video_on" v-if="myVideo"></i>
        <i class="icon iconfont icon-video_off" v-else></i>
        <span>Camera</span>
      </div>
      <div class="menu-item" @click="selectAudio">
        <i class="icon iconfont icon-speaker_on" v-if="myAudio"></i>
        <i class="icon iconfont icon-speaker_off" v-else></i>
        <span>Sound</span>
      </div>
      <div class="menu-item" :class="videoDeviceList.length < 2 ? 'no' : ''" @click="selectCamera">
        <i class="icon iconfont icon-qiehuanshexiangtou"></i>
        <span>Switch</span>
      </div>
      <div class="menu-item" @click="selectInvite">
        <i class="icon iconfont icon-add"></i>
        <span>invite</span>
      </div>
      <div class="menu-item" @click="outClick">
        <i class="icon iconfont icon-tuichu"></i>
        <span>Exit</span>
      </div>
    </van-popup>
    <div class="repair" :class="{ open: isShowRepair }" @click="repairClick">No sound? Click repair</div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { Dialog } from "vant";
import moment from "moment";
import RTCClient from "./js/agora-rtc-client";
import StreamPlayer from "./components/stream-player";
import AgoraRTC from "agora-rtc-sdk";
import { begin } from "./js/remOnresize";
export default {
  name: "video-talk",
  data() {
    return {
      option: {
        appid: "",
        token: "",
        uid: null,
        channel: "",
      },
      show: false,
      localStream: null,
      myVideo: false,
      myAudio: false,
      remoteStreams: [],
      videoDeviceList: [],
      msgId: "",
      isExit: false,
      isShowRepair: false,
    };
  },
  components: {
    StreamPlayer,
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
    agoraId() {
      return this.$route.query.agoraId;
    },
    type() {
      return this.$route.query.type;
    },
    //是否是发起人进入，发起人进入为true
    isInitiator() {
      return this.$route.query.isInitiator || false;
    },

    is_weixn() {
      let ua = navigator.userAgent.toLowerCase();
      // console.log(ua,'usususuusaususauuaauuasuauauauua')
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
  },
  async created() {
    this.msgId = this.$route.query.msgId;
    this.init();
    let query = `
        query{
          agoraQuery{
            get(id:"${this.agoraId}"){
              id
              userId
              exhibitionId
              member{
                avatarUrl
                userId
                name
                nickName
              }
              exhibitor{
                company{
                  name
                  logo
                }
              }
              exhibitorId
            }
          }
        }
      `;
    let opt = {
      query: query,
      variables: {},
    };
    let data = await this.graphqlPost(opt);
    console.log(data, "resss 洽谈间");
    let res = JSON.parse(JSON.stringify(data.data.agoraQuery.get));
    if (!res.id) {
      this.$toast.fail("There is an error in the chat room, please re-enter");
      return;
    }
    this.agoraRoom = res;
    this.$store.commit("setExhibitionId", res.exhibitionId);
    // let window.location.href=''
    let req = {
      title: "I would like to recommend a video chat room for you",
      desc: `I invite you to join the video chat room with ${res.exhibitor.company.name}...`,
      link: `https://men.zhanshangxiu.com/video-talk?msgId=${this.msgId}&agoraId=${this.agoraRoom.id}&type=visitor`,
      imgUrl: res.exhibitor.company.logo,
    };
    this.shareToWechat(req);
    let bool = AgoraRTC.checkSystemRequirements();
    if (!bool) {
      Dialog({ message: "If it does not work properly, open it in a Chrome browser or a Safari browser above ios11.0" });
      return;
    }
    let msgQuery = `
        query{
          agoraMessageQuery{
            get(id:"${this.msgId}"){
              state
              stateAt
            }
          }
        }
      `;
    let msgOpt = {
      query: msgQuery,
      variables: {},
    };
    let msgData = await this.graphqlPost(msgOpt);
    let msgRes = JSON.parse(JSON.stringify(msgData.data.agoraMessageQuery.get));
    console.log(msgRes, "sss");
    //  unread
    if (msgRes.state == "expire") {
      Dialog.alert({
        title: "Attention",
        message: "Sorry, the video chat room is closed",
      }).then(() => {
        if (this.is_weixn && (this.type == "user" || this.type == "service")) {
          if (this.type == "user") {
            this.LinkChatTalkUser({ exhibitorId: this.agoraRoom.exhibitorId, userId: this.agoraRoom.userId });
          } else {
            this.LinkChatTalk({ exhibitorId: this.agoraRoom.exhibitorId, userId: this.agoraRoom.userId });
          }
        } else {
          this.out();
        }
        // on close
      });
      return;
    }
    this.option = {
      appid: "db992c4127c6454f9229216503d3e839",
      token: "",
      uid: null,
      channel: this.agoraRoom.id,
    };
    //uid 用户为2 客服为1   游客为系统分配
    if (this.type == "user") {
      //用户
      this.option.uid = Number(2);
    } else if (this.type == "service" && this.isInitiator) {
      //客服
      this.option.uid = Number(1);
    } else {
      //游客
      this.option.uid = Number(0);
    }
    let tokenOpt = {
      channelName: this.agoraRoom.id, //频道名称
      userId: "",
      privileges: [1000],
    };
    let tokenRes = await this.getVideoToken(tokenOpt);
    this.option.token = tokenRes;
    console.log(this.option.uid, "uid");
    this.joinEvent();
  },
  destroyed() {
    window.removeEventListener("beforeunload", (e) => this.beforeunloadFn(e));
  },
  beforeDestroy() {
    this.beforeunloadFn();
  },
  mounted() {
    window.addEventListener("beforeunload", (e) => this.beforeunloadFn(e));
    begin();
    this.$nextTick(() => {
      this.doResize();
    });
  },
  methods: {
    ...mapActions({
      getMessageToken: "talk/getMessageToken",
      addAgoraMessage: "talk/addAgoraMessage",
      upDateStateAgoraMessage: "talk/upDateStateAgoraMessage",
      shareToWechat: "wxShare/shareToWechat",
      agoraNotify: "talk/agoraNotify",
      getVideoToken: "talk/getVideoToken",
      graphqlPost: "en/graphqlPostByZXS",
      LinkChatTalk: "linkTo/LinkChatTalk",
      LinkChatTalkUser: "linkTo/LinkChatTalkUser",
    }),
    doResize() {
      console.log("触发");
      setTimeout(function() {
        //手动触发窗口resize事件
        if (document.createEvent) {
          var event = document.createEvent("HTMLEvents");
          event.initEvent("resize", true, true);
          window.dispatchEvent(event);
        } else if (document.createEventObject) {
          window.fireEvent("onresize");
        }
      }, 50);
    },
    //开始计时
    startTime() {
      // setTimeout(() => {
      this.isShowRepair = true;
      setTimeout(() => {
        this.isShowRepair = false;
      }, 15000);
      // }, 3000);
    },
    //点击当前
    streamClick(e) {
      if (e.isAudioRepair) {
        return;
      }
      e.stream.stop();
      e.stream.play(`${e.id}`, { muted: false });
      e.isAudioRepair = true;
    },
    repairClick() {
      this.$nextTick(() => {
        // console.log('修复')
        this.remoteStreams.forEach((e) => {
          e.stream.stop();
          e.stream.play(`${e.id}`, { muted: false });
          e.isAudioRepair = true;
        });
        this.isShowRepair = false;
      });
    },
    async beforeunloadFn(e) {
      this.out();
      // await this.exit();
      // this.localStream=null;
      // this.remoteStreams=[];
      // this.rtc=null;
    },
    exit() {
      return new Promise((resolve, reject) => {
        // console.log(this.rtc,'sss')
        if (this.rtc && this.rtc.client) {
          this.rtc
            .leaveChannel()
            .then(() => {
              resolve(true);
            })
            .catch((err) => {
              // console.log('leave error', err)
              reject(err);
            });
        } else {
          resolve(true);
        }
      });
    },
    init() {
      this.rtc = new RTCClient();
      let rtc = this.rtc;
      rtc.on("stream-added", (evt) => {
        let { stream } = evt;
        console.log("远端音视频流已添加：", stream.getId());
        rtc.client.subscribe(stream);
      });

      rtc.on("stream-subscribed", (evt) => {
        let { stream } = evt;
        console.log(stream, "stream 接收音视频流");
        console.log("已接收远端音视频流：", stream.getId());
        if (!this.remoteStreams.find((it) => it.id === stream.getId())) {
          let mode = {
            stream: stream,
            id: stream.getId(),
            video: stream.getVideoTrack().enabled,
            audio: stream.getAudioTrack().enabled,
            isAudioRepair: false,
          };
          this.remoteStreams.push(mode);
        }
      });

      rtc.on("stream-removed", (evt) => {
        let { stream } = evt;
        console.log("对方删除远端音视频流：", stream.getId());
        this.remoteStreams = this.remoteStreams.filter((it) => it.id !== stream.getId());
      });

      rtc.on("peer-online", (evt) => {
        console.log(`该回调提示有远端用户： ${evt.uid}`);
      });

      rtc.on("peer-leave", (evt) => {
        // this.$message(`有远端用户离线 ${evt.uid}`)
        console.log("有远端用户离线", evt.uid);
        this.remoteStreams = this.remoteStreams.filter((it) => it.id !== evt.uid);
        if (evt.uid == 1) {
          this.over();
        }
      });

      //远端音视频状态改变
      rtc.on("mute-video", (evt) => {
        console.log("对方禁用视频：", evt.uid);
        this.remoteStreams.map((e) => {
          if (e.id == evt.uid) {
            e.video = false;
          }
        });
      });
      rtc.on("mute-audio", (evt) => {
        console.log("对方禁用音频：", evt.uid);
        this.remoteStreams.map((e) => {
          if (e.id == evt.uid) {
            e.audio = false;
          }
        });
      });
      rtc.on("unmute-video", (evt) => {
        console.log("对方启用视频：", evt.uid);
        this.remoteStreams.map((e) => {
          if (e.id == evt.uid) {
            e.video = true;
          }
        });
      });
      rtc.on("unmute-audio", (evt) => {
        console.log("对方启用音频：", evt.uid);
        this.remoteStreams.map((e) => {
          if (e.id == evt.uid) {
            e.audio = true;
          }
        });
      });
    },

    //进入房间
    joinEvent() {
      this.rtc
        .joinChannel(this.option)
        .then(() => {
          //链接成功
          this.rtc
            .publishStream()
            .then(async (stream) => {
              // this.$message({
              //   message: 'Publish Success',
              //   type: 'success'
              // });
              console.log("发布本地流成功");
              this.localStream = stream;
              this.myVideo = stream.video;
              this.myAudio = stream.audio;
              await this.getVideoDeviceList();
              this.startTime();
              this.show = true;
            })
            .catch((err) => {
              console.log("发布本地流失败", err);
            });
        })
        .catch((err) => {
          console.log("加入房间失败", err);
        });
    },

    //本地流操作
    //点击摄像头 开启/关闭
    selectVideo() {
      let bool = null;
      if (this.myVideo) {
        //禁用视频
        bool = this.localStream.muteVideo();
        this.myVideo = !bool;
      } else {
        //打开视频
        bool = this.localStream.unmuteVideo();
        this.myVideo = bool;
      }
    },
    //声音  开启/关闭
    selectAudio() {
      let bool = null;
      if (this.myAudio) {
        bool = this.localStream.muteAudio();
        this.myAudio = !bool;
      } else {
        bool = this.localStream.unmuteAudio();
        this.myAudio = bool;
      }
    },
    getVideoDeviceList() {
      return new Promise((resolve, reject) => {
        let vList = [];
        AgoraRTC.getDevices((devices) => {
          devices.forEach((e) => {
            if (e.kind === "videoinput") {
              vList.push(e);
            }
            if (e.label == this.localStream.videoName && !this.myDeviceId) {
              this.myDeviceId = e.deviceId;
            }
          });
          this.videoDeviceList = vList;
          resolve();
        });
      });
    },
    //摄像头  前置/后置
    async selectCamera() {
      // if(!this.videoDeviceList.length){
      await this.getVideoDeviceList();
      // }
      console.log(this.myDeviceId, "当前设备id");
      console.log(this.localStream, "本地流");
      console.log(this.videoDeviceList, "ssss摄像头列表");
      let that = this;
      this.videoDeviceList.forEach((e) => {
        console.log(e.deviceId, "  eeeeee deviceId");
        console.log(e.groupId, " eeeeee groupId");
        console.log(e.kind, " eeeeee kind");
        console.log(e.label, " eeeeee label");
        if (e.deviceId != this.myDeviceId) {
          console.log(e.deviceId, "不等于");
          this.localStream.switchDevice(
            "video",
            e.deviceId,
            () => {
              console.log(that.myDeviceId, "我当前的");
              that.myDeviceId = e.deviceId;
              console.log("成功");
            },
            (err) => {
              console.log(err, "失败");
            }
          );
        }
      });
      // .then((devices)=>{
      //   console.log(devices,'摄像头ssss')
      // }).catch(err=>{
      //   console.log(err,'失败')
      // })
    },
    //邀请
    selectInvite() {
      let url = `https://men.zhanshangxiu.com/video-talk?msgId=${this.msgId}&agoraId=${this.agoraRoom.id}&type=visitor`;
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", url);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        Dialog.alert({
          title: "Attention",
          message: "The link has been copied，open it in a Chrome browser or a Safari browser above ios11.0",
          confirmButtonText: "Confirm",
        }).then(() => {
          // on close
        });
      } else {
        Dialog.alert({
          title: "Attention",
          message: "Link replication failed, please try again",
          confirmButtonText: "Confirm",
        }).then(() => {
          // on close
        });
      }
      document.body.removeChild(input);
    },
    //客服退出 洽谈结束
    async over() {
      let myUid = this.localStream.getId();
      if (this.is_weixn && myUid == 2) {
        //微信环境 用户身份 返回到页面
        this.$toast.fail("Video chat is over");
        let res = await this.exit();
        if (res === true) {
          this.LinkChatTalkUser({ exhibitorId: this.agoraRoom.exhibitorId, userId: this.agoraRoom.userId });
        }
      } else {
        this.$toast.fail("Video chat is over");
        setTimeout(() => {
          this.out();
        }, 2000);
      }
    },

    outClick() {
      Dialog.confirm({
        message: "Confirm exit？",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      })
        .then(() => {
          this.out();
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    },
    //退出
    async out() {
      if (this.isExit) {
        return;
      }
      let res = await this.exit();
      let myUid = null;
      if (res === true) {
        if (this.localStream) {
          myUid = this.localStream.getId();
        }
        console.log("退出成功");
        if (myUid == 1) {
          let opt = {
            messageIds: [this.msgId],
            state: "expire",
          };
          let res = await this.upDateStateAgoraMessage(opt);
          console.log(res, "客服结束");
          if (res && res.result) {
            this.$toast.success("Video chat is over");
            if (this.is_weixn && (this.type == "user" || this.type == "service")) {
              if (this.type == "user") {
                this.LinkChatTalkUser({ exhibitorId: this.agoraRoom.exhibitorId, userId: this.agoraRoom.userId });
              } else {
                this.LinkChatTalk({ exhibitorId: this.agoraRoom.exhibitorId, userId: this.agoraRoom.userId });
              }
            } else {
              window.opener = null;
              window.open("", "_self");
              window.location.href = "about:blank";
              window.close();
            }
          } else {
            window.opener = null;
            window.open("", "_self");
            window.location.href = "about:blank";
            window.close();
          }
        }
        this.rtc = null;
        this.localStream = null;
        this.remoteStreams = [];
        if (myUid != 1) {
          window.opener = null;
          window.open("", "_self");
          window.location.href = "about:blank";
          window.close();
        }
        this.isExit = true;
      } else {
        console.log(res, "退出失败");
      }
    },
  },
};
</script>
<style lang="scss">
@media screen and (min-width: 750px) {
  * {
    font-size: inherit;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (min-width: 750px) {
  .video_bottom {
    display: none;
  }
  .pc_bottom {
    position: absolute;
    padding: 0 20px;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 96px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    box-shadow: 0px 2px 3px 0px rgba(106, 100, 100, 0.1);
    .handle {
      display: flex;
      align-items: center;
      .menu-item {
        height: 74px;
        width: 74px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        &.no {
          .icon {
            color: #999;
          }
          .span {
            color: #999;
          }
        }
        &:hover {
          background-color: #f0f2f5;
          cursor: pointer;
        }
        .iconfont {
          font-size: 24px;
          transform: scale(1.8);
          color: #333;
          margin-bottom: 8px;
          &.off {
            color: #999;
          }
        }
      }
    }
    .exit {
      height: 74px;
      width: 74px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      cursor: pointer;
      .icon_div {
        height: 40px;
        width: 40px;
        border-radius: 50%;
        overflow: hidden;
        background: #ff5b28;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 5px;
        .iconfont {
          font-size: 24px;
          color: #fff;
        }
      }
    }
  }
  .video-talk {
    color: #333;
    width: 100%;
    height: 100%;
    position: absolute;
    background: #f0f2f5;
    overflow: auto;
    .video_wrap {
      padding: 10px 20px 104px;
      height: 100%;
      overflow: auto;
      position: relative;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(2, 1fr);
      &.list_3 {
        grid-template-columns: repeat(2, 1fr);
      }
      .stream {
        padding: 10px;
        height: 100%;
        width: 100%;
        grid-area: auto/ auto/ auto/ auto;

        .stream_video {
          width: 100%;
          height: 100%;
          position: relative;
          border-radius: 5px;
          overflow: hidden;
          background: #fff;
          .agora-video-player {
            border-radius: 5px;
            overflow: hidden;
            > div {
              border-radius: 5px;
            }
          }
          .close_video {
            width: 100%;
            height: 100%;
            position: absolute;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            z-index: 9;
            top: 0;
            left: 0;
            color: #666;
            .icon {
              font-size: 46px;
              transform: scale(1.5);
              margin-bottom: 10px;
            }
          }
        }
        &.item_count1,
        &.item_count2,
        &.item_count3 {
          grid-area: 1 / 1 / 3 / 3;
        }
      }
    }
    .repair {
      position: fixed;
      top: -60px;
      transition: top 0.5s;
      left: 50%;
      transform: translateX(-50%);
      height: 48px;
      display: flex;
      white-space: nowrap;
      border-radius: 5px;
      align-items: center;
      padding: 0 60px;
      font-size: 20px;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      z-index: 9999;
      user-select: none;
      cursor: pointer;
      &.open {
        top: 40px;
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .video-talk {
    background: #e5e5e5;
    height: 100vh;
    position: relative;
    width: 100vw;
    overflow: hidden;
    .repair {
      position: fixed;
      top: -0.7rem;
      transition: top 0.5s;
      left: 50%;
      transform: translateX(-50%);
      height: 0.64rem;
      display: flex;
      white-space: nowrap;
      border-radius: 0.05rem;
      align-items: center;
      padding: 0 0.73rem;
      font-size: 0.26rem;
      background: rgba(0, 0, 0, 0.3);
      color: #fff;
      z-index: 999;
      user-select: none;
      &.open {
        top: 0.3rem;
      }
    }
    .video_wrap {
      width: 100vw;
      height: 100vh;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      position: relative;

      .stream1.stream-t1 {
        width: 2rem;
        height: 3rem;
        border-radius: 0.1rem;
        overflow: hidden;
        right: 0.3rem;
        top: 0.3rem;
        z-index: 10;
        position: absolute;
      }
      .stream {
        width: 50%;
        position: relative;
        .close_video {
          width: 100%;
          height: 100%;
          position: absolute;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          z-index: 9;
          top: 0;
          left: 0;
          color: #666;
          .icon {
            font-size: 0.8rem;
            transform: scale(1.5);
            margin-bottom: 0.1rem;
          }
        }
        &.stream0 {
          width: 100%;
          height: 100%;
          left: 0;
          right: 0;
          &.stream-t1 {
            position: absolute;
          }
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        &.stream-t2,
        &.stream-t3 {
          position: relative;
          border-radius: 0;
          height: 50%;
          width: 50%;
        }
        &.stream-t4,
        &.stream-t5 {
          position: relative;
          border-radius: 0;
          height: 33.33%;
          width: 50%;
        }
        &.stream-t6,
        &.stream-t7,
        &.stream-t8 {
          width: 33.33%;
          height: 33.33%;
        }
        //本地流
        .stream_video {
          width: 100%;
          height: 100%;
        }
      }
    }
    .video_bottom {
      height: 1.8rem;
      width: 100vw;
      box-shadow: 0 -0.05rem 0.15 0 rgba(0, 0, 0, 0.15);
      border-radius: 0.2rem 0.2rem 0 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .menu-item {
        text-align: center;
        height: 1.8rem;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        &.no {
          .icon {
            color: #999;
          }
          .span {
            color: #999;
          }
        }
        .icon {
          width: 0.84rem;
          height: 0.84rem;
          text-align: center;
          line-height: 0.84rem;
          border-radius: 50%;
          background: #f2f2f2;
          font-size: 28px;
          color: #333;
        }
        span {
          color: #666;
          font-size: 0.22rem;
          margin-top: 0.05rem;
        }
        .icon-tuichu {
          background: #ff5b28;
          color: #fff;
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  // opacity: ;
  // overflow: hidden;
  // transition: height .3s;
  // &.open{

  // }
  // position: absolute;
  // width: 100%;
  // top: 0;
  // left: 0;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
